import React from 'react';
import { ChevronRight } from 'lucide-react';

import { cn } from '../lib/utils';

/**
 * The one expander glyph (DESIGN_SYSTEM.md §5 "Pressed and expanded"): points
 * right when closed and rotates to point down when open. Decorative — the
 * trigger carries aria-expanded and aria-controls. The global reduced-motion
 * guard in index.css covers the rotation.
 */
export const DisclosureChevron: React.FC<{ open: boolean; className?: string }> = ({ open, className }) => (
  <ChevronRight
    aria-hidden="true"
    className={cn('h-4 w-4 shrink-0 transition-transform', open && 'rotate-90', className)}
  />
);
